module.exports = __webpack_public_path__ + "img/back rise.a80f699f.png";